import {ChangeEventHandler, FormEventHandler, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Button from '../../../common/component/Button';
import {pToast} from '../../../common/container/PToast';
import EventRowItemV4 from '../EventRowItemV4';

interface IProps {
  isCompleted: boolean;
  isDisabled?: boolean;
  onSubmit: (input: string) => void;
  onClickForm?: () => void;
}

export default function QuizInputV4({
  isCompleted,
  isDisabled,
  onSubmit,
  onClickForm,
}: IProps) {
  const {t} = useTranslation();
  const [input, setInput] = useState('');

  const handleChangeInput: ChangeEventHandler<HTMLInputElement> = e => {
    const inputValue = e.currentTarget.value;
    if (inputValue.length > 100) {
      setInput(inputValue.substring(0, 100));
      pToast(t('crm_quiz_answer_exceed_toast'));
    } else {
      setInput(inputValue);
    }
  };

  const handleSubmit: FormEventHandler = e => {
    if (isCompleted) return;
    e.preventDefault();
    onSubmit(input);
  };

  useEffect(() => {
    isCompleted && setInput('');
  }, [isCompleted]);

  return (
    <form onSubmit={handleSubmit} onClick={onClickForm}>
      <EventRowItemV4
        isRound
        className={cn('!pr-0 !min-h-[auto] h-52', {
          'pointer-events-none bg-white/15': isCompleted,
          'bg-white': !isCompleted,
        })}
        leftElementClassName="flex-auto"
        leftElement={
          <input
            type="text"
            className={cn(
              's13-regular-black',
              'placeholder:text-dark-grey-11',
              'outline-0 border-0 leading-19 tracking-[-0.4px]',
              'bg-transparent'
            )}
            value={input}
            placeholder={isCompleted ? undefined : t('crm_quiz_before_enter')}
            onChange={handleChangeInput}
            disabled={isCompleted}
            data-testid="input"
          />
        }
        rightElementClassName="flex-shrink-0 self-stretch"
        rightElement={
          <Button
            onSubmit={handleSubmit}
            className={cn(
              'h-full px-18 outline-0 border-0 leading-19 tracking-[-0.4px]',
              {
                's13-regular-white opacity-50': isCompleted,
                's13-regular-darkGrey11': !isCompleted && !input,
                's13-regular-red': !isCompleted && input,
              }
            )}
            disabled={isCompleted || !input || isDisabled}
            data-testid="button"
          >
            {/* TODO: V4 로딩 표시 */}
            {t(
              isCompleted
                ? 'crm_quiz_submit_complete_button'
                : 'crm_quiz_submit_button'
            )}
          </Button>
        }
        data-testid="event-row-item"
      />
    </form>
  );
}
